import React from "react";
import { Document, Page, Text, View, StyleSheet, Font } from "@react-pdf/renderer";


import HeaderSection from "./components/HeaderSection";
import EmisorSection from "./components/EmisorSection";
import ClienteSection from "./components/ClienteSection";
import DgiSection from "./components/DgiSection";
import ItemsTable from "./components/ItemsTable";
import ItbmsSection from "./components/ItbmsSection";
import TotalsSection from "./components/TotalsSection";
import PaymentSection from "./components/PaymentSection";
import LegalFooter from "./components/LegalFooter";

import GeistRegular from "./fonts/Geist/static/Geist-Regular.ttf";
import GeistMedium from "./fonts/Geist/static/Geist-Medium.ttf";
import GeistBold from "./fonts/Geist/static/Geist-Bold.ttf";
import { RenderIf } from "../utils/RenderIf";


Font.register({
  family: "Geist",
  fonts: [
    { src: GeistRegular, fontWeight: 400 },
    { src: GeistMedium, fontWeight: 500 },
    { src: GeistBold, fontWeight: 700 },
  ],
});

const money = (n) => `$${Number(n).toFixed(2)}`;
const COLORS = {
  softBlue: "#EFF6FF",     // fondo azul pálido
  deepBlue: "#1E3A8A",     // texto azul oscuro
  borderBlue: "#BFDBFE",   // borde suave
};
const S = StyleSheet.create({
  page: {
    fontFamily: "Geist",
    fontSize: 9,
    color: "#111",
    paddingTop: 28,
    paddingRight: 28,
    paddingBottom: 28,
    paddingLeft: 28,
    backgroundColor: "#fff",
  },

  row: { flexDirection: "row" },
  col: { flexGrow: 1, flexBasis: 0 },

  header: {
    position: "relative",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 50,
  },

  brandTitle: { fontSize: 12, fontWeight: 700 },
  label: {
    fontSize: 9,
    color: COLORS.deepBlue,
    textTransform: "uppercase",
    marginBottom: 2,
    fontWeight: 800
  },
  muted: { color: "#6b7280" },
  bold: { fontWeight: 700 },

  qrBox: {
    width: 92,
    height: 92,
    borderWidth: 1,
    borderColor: "#cbd5e1",
    borderStyle: "dashed",
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  qrText: { fontSize: 7, color: "#64748b", textAlign: "center", paddingLeft: 6, paddingRight: 6 },

  section: { marginTop: 10 },
  box: {
    borderWidth: 1,
    borderColor: COLORS.borderBlue,
    backgroundColor: COLORS.softBlue,
    borderRadius: 8,
    paddingTop: 10,
    paddingRight: 12,
    paddingBottom: 5,
    paddingLeft: 12,
  },

 // ===============================
// TABLE
// ===============================

table: {
  marginTop: 10,
  borderWidth: 1,
  borderColor: "#cbd5e1",
  borderRadius: 6,
  overflow: "hidden",
},

thead: {
  flexDirection: "row",
  backgroundColor: "#0f172a",
  paddingTop: 7,
  paddingRight: 8,
  paddingBottom: 7,
  paddingLeft: 8,
},

th: {
  color: "#fff",
  fontWeight: 700,
  fontSize: 8,
  paddingHorizontal: 2,
  borderRightWidth: 1,
  borderRightColor: "#334155",
},

// quitar borde última columna header
thLast: {
  borderRightWidth: 0,
},

tr: {
  flexDirection: "row",
  paddingTop: 7,
  paddingRight: 1,
  paddingBottom: 7,
  paddingLeft: 1,
  borderBottomWidth: 1,
  borderBottomColor: "#e2e8f0",
},

// CELDA BASE CON BORDE VERTICAL
td: {
  fontSize: 9,
  paddingHorizontal: 2,
  borderRightWidth: 1,
  borderRightColor: "#e2e8f0",
},

// quitar borde última columna
tdLast: {
  borderRightWidth: 0,
},

// ===============================
// COLUMNAS
// ===============================

cNo: { width: 22 },

cDesc: { flex: 1 },

cQty: { 
  width: 46, 
  textAlign: "right" 
},

cPU: {
  width: 90,
  textAlign: "right",
  paddingRight: 8,
},

cDU: {
  width: 90,
  textAlign: "right",
  paddingRight: 8,
},

cItbms: {
  width: 70,
  textAlign: "right",
},

cItem: { 
  width: 70, 
  textAlign: "right", 
  fontWeight: 700 
},

  split: {
    marginTop: 10,
    flexDirection: "row",
    gap: 10,
  },
  half: { flexGrow: 1, flexBasis: 0 },

  miniTable: {
    borderWidth: 1,
    borderColor: "#e5e7eb",
    borderRadius: 6,
    overflow: "hidden",
  },
  miniHead: {
    backgroundColor: "#111827",
    paddingTop: 6,
    paddingRight: 8,
    paddingBottom: 6,
    paddingLeft: 8,
  },
  miniHeadTxt: { color: "#fff", fontWeight: 700, fontSize: 8 },
  miniRow: {
    flexDirection: "row",
    paddingTop: 6,
    paddingRight: 8,
    paddingBottom: 6,
    paddingLeft: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#f1f5f9",
  },

  totalsBox: {
    borderWidth: 1,
    borderColor: "#e5e7eb",
    borderRadius: 6,
    overflow: "hidden",
  },
  totRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: 7,
    paddingRight: 10,
    paddingBottom: 7,
    paddingLeft: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#f1f5f9",
  },
  totFinal: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#0f172a",
    color: "#fff",
    paddingTop: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    fontSize: 11,
    fontWeight: 700,
  },

  noteLink: {
    marginTop: 8,
    fontSize: 8,
    color: "#334155",
  },

  footer: {
    marginTop: 14,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: "#e5e7eb",
    fontSize: 8,
    color: "#6b7280",
  },

  pageNumber: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 9,
    color: "#6b7280",
  },

  imageLogo: {
    width: 90,
    height: 70,
    marginVertical: 1,
    objectfit: 'cover',
    position: 'absolute',
    top: '-30',
    left: '0',
  },


  imageQr: {
    width: 170,
    height: 170,
    marginVertical: 1,
    objectfit: 'cover',
    // position: 'absolute',
    // top: '0',
    // right: '0',
  },


  imageContainer: {
    width: 90,
    height: 70,
    justifyContent: "center",
    alignItems: "center",
  },

  imageFit: {
    objectFit: "contain",
    width: "100%",
    height: "100%",
  },


  tdBase: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 6,
    borderRightWidth: 1,
    borderRightColor: "#e5e7eb",
  },

  th: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 8,
    borderRightWidth: 1,
    borderRightColor: "#334155",
    padding: 6,
  },

  lastCol: {
    borderRightWidth: 0,
  },
});


export default function InvoicePDF({ data }) {
  const items = data.items || [];

  const sum = (arr, fn) => arr.reduce((a, x) => a + fn(x), 0);
  const total = sum(items, (i) => i.valorItem);
  const totalImpuesto = sum(items, (i) => i.montoItbms);
  const totalNeto = total; // según tu ejemplo
  const valorTotal = total; // según tu ejemplo

  const itbmsRows = data.itbmsBreakdown || [
    { montoBase: 0, porcentaje: 0, impuesto: 0, label: "Total" },
  ];


  let doc_type = "invoice";

  return (
    <Document>
      <Page size="A4" style={S.page}>

        <HeaderSection S={S} data={data} doc_type={doc_type} />

        <EmisorSection S={S} data={data} />

        <ClienteSection S={S} data={data} />

        <DgiSection S={S} data={data} />

        <ItemsTable S={S} items={items} />

        <View style={S.split}>
          <ItbmsSection S={S} itbmsRows={itbmsRows} />
          <TotalsSection
            S={S}
            valorTotal={valorTotal}
            totalNeto={totalNeto}
            totalImpuesto={totalImpuesto}
            total={total}
          />
        </View>

        <PaymentSection S={S} data={data} />


        <Text
          style={S.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `Página ${pageNumber} de ${totalPages}`
          }
          fixed
        />

        <LegalFooter S={S} />
      </Page>
    </Document>
  );
}

